import { money } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const VaroLineOfCreditWhereToGo = gql`
  fragment VlocStartApplicationFragment on VlocStartApplication {
    id
    type
    educationalScreenId
  }

  fragment VlocGoToErrorFragment on GoToError {
    code
    errorTitle: title
    message
  }

  fragment VlocActiveFragment on VlocActive {
    accountId
    id
    type
  }

  fragment VlocApplicationDeniedFragment on VlocApplicationDenied {
    id
    type
    title
    description
    screenAnalytics: displayAnalytics {
      ...analytics
    }
  }

  fragment VlocNotEligibleToQualifyFragment on VlocNotEligibleToQualify {
    id
    type
    educationalScreenId
  }

  fragment VlocNotPreQualifiedFragment on VlocNotPreQualified {
    id
    type
    vlocNoBelieve {
      description
      subTitle
      title
      articleLink {
        ...LendingArticleLinkFragment
      }
    }
    vlocNotQualified {
      description
      footer
      optionItems
      subTitle
      title
    }
  }

  fragment VlocNotPreQualifiedCreditFrozenFragment on VlocNotPreQualifiedCreditFrozen {
    id
    type
    title
    description
    screenAnalytics: displayAnalytics {
      ...analytics
    }
  }

  fragment VlocPenaltyPeriodFragment on VlocPenaltyPeriod {
    id
    type
  }

  fragment VlocLostEligibilityFragment on VlocLostEligibility {
    id
    accountId
    type
    vlocLostEligibilityBody {
      ...VlocLostEligibilityBodyFragment
    }
    screenAnalytics: displayAnalytics {
      ...analytics
    }
  }

  fragment VlocPendingDisbursementFragment on VlocPendingDisbursement {
    id
    type
    title
    description
  }

  fragment VlocPreQualifiedFragment on VlocPreQualified {
    id
    type
    registrationInfoId
    headerTitle
    headerBody
    headerFooter
    vlocTiers {
      ...VlocTierFragment
    }
    displayAnalytics {
      ...analytics
    }
  }

  fragment VlocStartNewDisbursementFragment on VlocStartNewDisbursement {
    id
    type
    accountId
    headerTitle
    vlocTiers {
      ...VlocTierFragment
    }
    displayAnalytics {
      ...analytics
    }
  }

  fragment LendingArticleLinkFragment on LendingArticleLink {
    id
    copy
  }

  fragment VlocLostEligibilityBodyFragment on VlocLostEligibilityBody {
    title
    subTitle
    items {
      ...LostEligibilityItemsFragment
    }
  }

  fragment LostEligibilityItemsFragment on LostEligibilityItems {
    title
    subTitle
    options
    disclaimer1
    disclaimer2
  }

  fragment VlocTierFragment on VlocTier {
    id
    tierAmount {
      ...money
    }
    fee {
      ...money
    }
    term
    mothlyPayment
    onClickAnalytics {
      ...analytics
    }
  }

  query VaroLineOfCreditWhereToGo {
    varoLineOfCreditWhereToGo(input: null) {
      __typename
      ...VlocStartApplicationFragment
      ...VlocGoToErrorFragment
      ...VlocActiveFragment
      ...VlocApplicationDeniedFragment
      ...VlocNotEligibleToQualifyFragment
      ...VlocNotPreQualifiedFragment
      ...VlocNotPreQualifiedCreditFrozenFragment
      ...VlocPenaltyPeriodFragment
      ...VlocLostEligibilityFragment
      ...VlocPendingDisbursementFragment
      ...VlocPreQualifiedFragment
      ...VlocStartNewDisbursementFragment
    }
  }
  ${AnalyticsFragment}
  ${money}
`;

export default VaroLineOfCreditWhereToGo;
